import { ROUTES } from '../components/navigation';

export function isCallId(value) {
  return typeof value === 'string' && value.length > 0 && value.length <= 60 && !/[^A-Za-z0-9_-]/.test(value);
}

// Only a canonical call-detail destination is allowed, never an arbitrary return URL.
export function safeCallReturnTo(value) {
  if (typeof value !== 'string' || /[\s\\]/.test(value) || !value.startsWith(`${ROUTES.calls}?`)) return '';
  try {
    const url = new URL(value, 'https://sayable.invalid');
    const ids = url.searchParams.getAll('callId');
    if (url.pathname !== ROUTES.calls || url.hash || ids.length !== 1 || !isCallId(ids[0])) return '';
    if ([...url.searchParams.keys()].some(key => key !== 'callId')) return '';
    return `${ROUTES.calls}?callId=${encodeURIComponent(ids[0])}`;
  } catch (_error) {
    return '';
  }
}

export function callReturnToFromSearch(search) {
  const values = new URLSearchParams(search).getAll('returnTo');
  return values.length === 1 ? safeCallReturnTo(values[0]) : '';
}

export function signInPath(location = window.location) {
  const destination = location.pathname === ROUTES.calls
    ? safeCallReturnTo(`${location.pathname}${location.search}`)
    : location.pathname === '/signin' ? callReturnToFromSearch(location.search) : '';
  return destination ? `/signin?returnTo=${encodeURIComponent(destination)}` : '/signin';
}

export function redirectToCallSignIn() {
  const destination = signInPath();
  localStorage.removeItem('jwt_authorization');
  window.location.replace(destination);
}
